import {getDie} from "./dice";
import {IRollerResult} from "../_interfaces/IRoller";
import {s_char} from "../_signals/s_char";
import updChar from "../_sig_api/updChar";

export function rollStep(step: number, karma: boolean, vs: number) {

    const wounds = s_char.value.wunden;

    step = step - wounds;

    // Unabhängig von eventuellen Modifikatoren ist die Mindeststufe immer 1. Sieh Regelwert Seite 19
    if (step < 1) step = 1;
    let die = getDie(step);

    let sum = 0;
    let rolled: string[] = [];
    for (let i = 1; i <= die.d6; i++) {
        let roll = Math.floor(Math.random() * 6) + 1;
        sum += roll;
        rolled.push(roll.toString() + (roll === 6 ? '*' : ''));
        while (roll === 6) {
            roll = Math.floor(Math.random() * 6) + 1;
            sum += roll;
            rolled.push(roll.toString() + (roll === 6 ? '*' : ''));
        }
    }
    sum += die.mod;

    let karma_roll: string[] = [];
    if (karma) {
        const karmavalue = s_char.value.karma;
        if (karmavalue > 0) {
            let roll = Math.floor(Math.random() * 6) + 1;
            sum += roll;
            karma_roll.push(roll.toString() + (roll === 6 ? '*' : ''));
            while (roll === 6) {
                roll = Math.floor(Math.random() * 6) + 1;
                sum += roll;
                karma_roll.push(roll.toString() + (roll === 6 ? '*' : ''));
            }
            updChar([{k:'karma',v: (karmavalue - 1)}])
        } else {
            karma_roll.push('-');
        }
    } else {
        karma_roll.push('-');
    }

    // Unabhängig von Modifikatoren ist das Mindestergebnis einer Probe immer 1. Siehe Regelwerk Seite 18
    if (sum < 1) sum = 1;

    let success = false;
    let successes = 0;
    if (!isNaN(vs) && vs > 0) {
        success = (sum >= vs); // erfolg wenn größer oder gleich vs
        successes = Math.floor((sum - vs) / 5); // alles über dem vs vom ergebnis / 5 für zusätzlche erfolge
    }

    const time = new Date().getTime();
    // see rollBehave.result
    return {
        time: time,
        step: step,
        step_mod: 0,
        result: sum,
        rolled: rolled.join(', '),
        karma: karma_roll.join(', '),
        successes: successes,
        success: success,
        vs: vs,
        as: ''
    } as IRollerResult;
}
